<div class="table-container-body">
    <!-- Sitemap URLs Section -->
    <div *ngIf="scan?.urls?.length" class="mb-4">
        <table class="table table-fixed table-hover">
            <thead>
                <tr>
                    <th class="col-48" translate>URL from Sitemap</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let sitemapUrl of scan.urls">
                    <td class="text-wrap">{{ sitemapUrl }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Regular Links Section -->
    <div *ngIf="scan?.links?.length">
        <table class="table table-fixed table-hover">
            <thead>
                <tr>
                    <th class="col-42" translate>URL</th>
                    <th class="col-3 text-right" translate>Excluded</th>
                    <th class="col-3 text-right" translate>Added as internal</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let link of scan.links">
                    <td class="text-wrap">{{ link.url }}</td>
                    <td class="text-right">{{ link.excluded }}</td>
                    <td class="text-right">{{ link.added_as_internal }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
